import React from 'react'
import 'react-toastify/dist/ReactToastify.css';
import { ToastContainer, Slide } from 'react-toastify';

export default function InvoiceToast() {
    return (
      <>
      <ToastContainer
        position="top-center"
        newestOnTop={true}
        closeOnClick
        rtl={false}
        transition={Slide}
        pauseOnHover={false}
      />
      </>
      
    )
  }
